// TODO!: エラーメッセージは統一して処理したい
import firebase from 'firebase'
const cityId = process.env.VUE_APP_TEMP_CITY_ID || '';
const state = {
  user: {
    uid: '',
    isAnonymous: true,
    email: '',
    displayName: '',
  },
  isAuthed: false,
  data: {
    askForNotificationModalOpened: false,
    attributionModalOpened: false,
    attributionDef: {},
  }
}

const mutations = {
  setUserState (state, user) {
    state.user = user
  },
  setAuthed (state, isAuthed) {
    state.isAuthed = isAuthed
  },
  setAskForNotificationModalOpened (state, opened) {
    state.data.askForNotificationModalOpened = opened
  },
  setAttributionModalOpened (state, opened) {
    state.data.attributionModalOpened = opened
  },
  setAttributionDef (state, def) {
    state.data.attributionDef = def
  }
}

const authConfig = JSON.parse(process.env.VUE_APP_AUTH || '{}')  // 例→ {"line":1,"slp":0,"officer":1}
const actions = {
  setUser ( { commit, dispatch }, user ) {
    const initiateFunc = () => {
      // 親モジュールのactionsを呼び出す
      dispatch('getLogoSrc', null, { root: true })
      dispatch('getMem', null, { root: true })
      dispatch('getLid', null, { root: true })
      dispatch('getwss', null, { root: true })
    }
    if (!user) {
      // TODO!: 本来ここは発火しないはずなので要検証
      firebase.auth().signInAnonymously()
        .then(({user}) => {
          console.log('setUser: isAnonymous')
          commit('setUserState', user)
          commit('setAuthed', false)
          dispatch('unAuthedUserInitiation')  // TODO!: userUnAuthed重複
          initiateFunc()
        })
      return
    }
    if (user.isAnonymous) {
      console.log('setUser: isAnonymous')
      commit('setUserState', user)
      commit('setAuthed', false)
      dispatch('unAuthedUserInitiation')  // TODO!: userUnAuthed重複
      initiateFunc()
    } else {
      firebase.auth().currentUser.getIdTokenResult(true)
        .then((result) => {
          const userData = { ...user }
          if (authConfig.line === 1 && result.claims?.line) {
            userData.line = result.claims.line
          }
          if (authConfig.slp === 1 && result.claims?.slp) {
            userData.slp = result.claims.slp
          }
          // emailがliqlid.localで終わるか、uidがstaff:で始まる場合は、職員として扱う
          if (authConfig.officer === 1 && user.email?.endsWith('liqlid.local') || user.uid?.startsWith('staff:')) {
            userData.isGovStaff = true
          }
          commit('setUserState', userData)
          const authed = !!(userData.line || userData.slp || user.emailVerified)
          commit('setAuthed', authed)
          if (authed) {
            dispatch('userInitiation')
          } else {
            dispatch('unAuthedUserInitiation')  // TODO!: userUnAuthed重複
            initiateFunc()
          }
        })
    }
  },
  async signUpEmailAndPassword ( { dispatch }, { email, password, name } ) {
    let result = { success: false };
    const path = localStorage.getItem('pathBeforeSignup') || '/';

    try {
      firebase.auth().languageCode = "ja";
      await firebase.auth().createUserWithEmailAndPassword(email, password).then(async(user) => {
        await user.user.updateProfile({ displayName: name })
        await user.user.sendEmailVerification({ url: `${location.origin}${path}` })
        dispatch('setUser', user.user)
      })
      result.success = true;
    } catch (error) {
      console.error('error', error);
      result.error = error;
    }
    return result;
  },
  async linkEmailAndPassword ({ dispatch }, { email, password }) {
    const credential = firebase.auth.EmailAuthProvider.credential(email, password);
    const path = localStorage.getItem('pathBeforeSignup') || '/';
    let result = { success: false };
    try {
      // 登録済みなのに新規登録しようとした場合には、linkWithCredentialのエラーをキャッチする
      const {user} = await firebase.auth().currentUser.linkWithCredential(credential)
      firebase.auth().languageCode = "ja";
      await user.sendEmailVerification({ url: `${location.origin}${path}` });
      result.success = true;
    } catch (error) {
      console.error('error', error);
      result.error = error;
    } 
    return result;
  },
  async signInWithEmailAndPassword ( { dispatch, state }, { email, password, checkForPersist } ) {
    const persistenceOption = checkForPersist ? firebase.auth.Auth.Persistence.LOCAL : firebase.auth.Auth.Persistence.SESSION
    const path = localStorage.getItem('pathBeforeSignup') || '/';
    try {
      await firebase.auth().setPersistence(persistenceOption)
      // メールログインしたが未認証の場合に押せるのであれば、ここでsignOutする
      // if (state.user?.email) { await firebase.auth().signOut()}
      const { user } = await firebase.auth().signInWithEmailAndPassword(email, password)
      if (!user.emailVerified) {
        // 認証メールを再送
        firebase.auth().languageCode = "ja";
        await user.sendEmailVerification({ url: `${location.origin}${path}` })
        return { success: false, message: 'errorEmailNotVerified' }
      } else {
        dispatch('setUser', user)
      }
      return { success: true }
    } catch (err) {
      //console.log('signInWithEmailAndPassword. error: ', err.message)
      switch (err.message) {
        case 'The email address is badly formatted.':
          return { success: false, message: 'errorEmailInValid' }
        case 'There is no user record corresponding to this identifier. The user may have been deleted.':
          return { success: false, message: 'errorNoAccount' }
        case 'The password is invalid or the user does not have a password.':
          return { success: false, message: 'errorPasswordInvalid' }
        case 'The user account has been disabled by an administrator.':
          return { success: false, message: 'errorAccountDisabled' }
        default:
          // TODO: Sentryに送る
          console.error(err)
          return { success: false, message: 'errorUnknown' }
      }
    }
  },
  async linkOauth ( { dispatch, context }, { provider, code, state, mode } ) {
    const clientId = mode != "replace" ? process.env.VUE_APP_LINE_CLIENT_ID : process.env.VUE_APP_LINE_CLIENT_ID_OLD
    // TODO: まだほぼLINEに最適化されている状態だが、xIDなどでも使えるようにする
    const sessionId = localStorage.getItem(`${clientId}:${state}`)
    const redirect_uri = `${window.location.origin}/${provider}authhandle?mode=${mode}`
    // CloudFunctionsのlineLoginCallbackを呼び出す。code,state,sessionIdを渡す
    const functions = firebase.functions()
    // TODO: 名称検討。現状はlineLoginCallback or xidLoginCallback。
    const loginCallback = functions.httpsCallable(`${provider}LoginCallback`)
    // console.log('call with this', JSON.stringify({ code, state, sessionId, redirect_uri, mode }))
    const { data } = await loginCallback({ code, state, sessionId, redirect_uri, mode })
    // console.log("data", JSON.stringify(data))
    if (data.customToken) {
      await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
      // サインインする
      dispatch('useCustomToken', data.customToken)
      return ({ success: true, makeSignUp: false })
    } else if (data.accountExists && data.merged) {
      // エラーなので、それを返す
      return ({ success: false, accountExists: true, merged: true })
    } else if (!data.accountExists && data.error) {
      return ({ success: false, accountExists: false, error: data.error })
    } else {
      return ({ name: data.name, picture: data.picture, success: true, makeSignUp: true, state: data.state })
    }
  },
  async signUpOauth ( { dispatch, context }, { provider, state, name } ) {
    // TODO! LINEのみに対応
    const self = this
    
    // TODO: まだほぼLINEに最適化されている状態だが、xIDなどでも使えるようにする
    const clientId = process.env.VUE_APP_LINE_CLIENT_ID
    const sessionId = localStorage.getItem(`${clientId}:${state}`)
    const functions = firebase.functions()
    const signUpHandle = functions.httpsCallable(`${provider}SignUp`)
    const { data } = await signUpHandle({ sessionId, state, name })
    if (data.customToken) {
      // サインインする
      dispatch('useCustomToken', data.customToken)
      return ({ success: true })
    } else {
      console.error('signUpOauth. error: ', data)
      return ({ success: false })
    }
  },
  linkPhone ( { dispatch }, { phoneNumber, recaptchaVerifier, verificationCode } ) {
    // TODO!: まだ適当に書いてるので要確認
    const provider = new firebase.auth.PhoneAuthProvider()
    provider.verifyPhoneNumber(phoneNumber, recaptchaVerifier)
      .then(verificationId => {
        const credential = firebase.auth.PhoneAuthProvider.credential(verificationId, verificationCode)
        firebase.auth().currentUser.linkWithCredential(credential)
      })
      .then((user) => {
        //console.log('linkPhone. uid: ', user.uid)
        dispatch('setUser', user)
      })
  },
  useCustomToken ( { dispatch }, token ) {  // LINE, xID, etc.
    return firebase.auth().signInWithCustomToken(token).then((user) => {
      dispatch('setUser', user.user)
    }).then(() => {
      return { success: true }
    }).catch((error) => {
      console.error('useCustomToken. error: ', error)
      return { success: false, error }
    })
  },
  logout( { dispatch } ) {
    //console.log('logout')
    firebase.auth().signOut().then(() => {
      firebase.auth().signInAnonymously().then((user) => {
        dispatch('setUser', user.user)
      }).then(() => {
        // 再読み込み
        location.reload()
      })
    })
  },
  resetPassword: async function( { dispatch }, email ) {
    //console.log('resetPassword')
    try {
      await firebase.auth().sendPasswordResetEmail(email, { url: `${location.origin}/home?account=reset` })
      return { success: true }
    } catch (error) {
      return { success: false, error }
    }
  },
  updateName( { dispatch }, {name} ) {
    //console.log('updateName')
    //console.log('name', name)
    // TODO: Firestore側も更新する。なお、現状はこの関数を使っている処理はそれぞれFirestoreを更新している。
    const res = firebase.auth().currentUser.updateProfile({ displayName: name }).then((user) => {
      dispatch('setUser', user)
      return { success: true }
    })
    .catch((error) => {
      console.error(error)
      return { success: false, error }
    })
    return res
  },
  updateEmail: async function( { dispatch }, {newEmail, currentEmail, currentPassword} ) {
    //console.log('updateEmail')
    const path = localStorage.getItem('pathBeforeSignup') || '/';
    try {
      const credential = await firebase.auth.EmailAuthProvider.credential(currentEmail, currentPassword)
      await firebase.auth().currentUser.reauthenticateWithCredential(credential)
      await firebase.auth().currentUser.updateEmail(newEmail).then((user) => {
        dispatch('setUser', user)
      })
      firebase.auth().languageCode = "ja";
      await firebase.auth().currentUser.sendEmailVerification({ url: `${location.origin}${path}` })
      const message = '更新しました。メールアドレス宛に送信した認証メールのリンクをクリックしてください。'
      alert(message)
      // 再読み込み
      location.reload()
      return { success: true, message: message}
    } catch (error) {
      console.error(error)
      if (error.code === 'auth/email-already-in-use') {
        return { success: false, message: 'メールアドレスが既に使用されています。'}
      } else if (error.code === 'auth/requires-recent-login') {
        return { success: false, message: '認証が必要です。やり直してください。'}
      } else if (error.code === 'auth/invalid-email') {
        return { success: false, message: 'メールアドレスが不正です。'}
      } else if (error.code === 'auth/weak-password') {
        return { success: false, message: 'パスワードが簡単すぎます。'}
      } else if (error.code === 'auth/wrong-password') {
        return { success: false, message: 'パスワードが違います。'}
      } else if (error.code === 'auth/operation-not-allowed') {
        return { success: false, message: 'メールアドレスの変更は許可されていません。'}
      } else if (error.code === 'auth/user-not-found') {
        return { success: false, message: 'ユーザーが見つかりません。'}
      } else if (error.code === 'auth/user-disabled') {
        return { success: false, message: 'ユーザーが無効です。'}
      } else if (error.code === 'auth/too-many-requests') {
        return { success: false, message: 'リクエストが多すぎます。時間をおいてやり直してください。'}
      } else {
        return { success: false, message: 'エラーが発生しました。再度やり直してください。'}
      }
    }
  },
  updatePassword: async function( { dispatch }, {newPassword, currentEmail, currentPassword} ) {
    //console.log('updatePassword')
    try {
      const credential = await firebase.auth.EmailAuthProvider.credential(currentEmail, currentPassword)
      await firebase.auth().currentUser.reauthenticateWithCredential(credential)
      await firebase.auth().currentUser.updatePassword(newPassword).then((user) => {
        dispatch('setUser', user)
      })
      const message = '更新しました。再読み込みします。'
      alert(message)
      // 再読み込み
      location.reload()
      return { success: true, message: message}
    } catch (error) {
      console.error(error)
      if (error.code === 'auth/email-already-in-use') {
        return { success: false, message: 'メールアドレスが既に使用されています。'}
      } else if (error.code === 'auth/requires-recent-login') {
        return { success: false, message: '認証が必要です。やり直してください。'}
      } else if (error.code === 'auth/invalid-email') {
        return { success: false, message: 'メールアドレスが不正です。'}
      } else if (error.code === 'auth/weak-password') {
        return { success: false, message: 'パスワードが簡単すぎます。'}
      } else if (error.code === 'auth/wrong-password') {
        return { success: false, message: 'パスワードが違います。'}
      } else if (error.code === 'auth/operation-not-allowed') {
        return { success: false, message: 'メールアドレスの変更は許可されていません。'}
      } else if (error.code === 'auth/user-not-found') {
        return { success: false, message: 'ユーザーが見つかりません。'}
      } else if (error.code === 'auth/user-disabled') {
        return { success: false, message: 'ユーザーが無効です。'}
      } else if (error.code === 'auth/too-many-requests') {
        return { success: false, message: 'リクエストが多すぎます。時間をおいてやり直してください。'}
      } else {
        return { success: false, message: 'エラーが発生しました。再度やり直してください。'}
      }
    }
  },
  initAuth({commit, dispatch}){
    //console.log("initAuth")
    firebase.auth().onAuthStateChanged(async user => {
      await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
      // line customClaimsの取得
      if (user?.uid) {
        // const result = await firebase.auth().currentUser.getIdTokenResult(true)
        // const lineCustomClaims = result.claims?.line || ''
        // const slpCustomClaims = result.claims?.slp || ''

        // if (!lineCustomClaims && !slpCustomClaims && (!user.email || (user.email && !user.emailVerified))) {
        //   firebase.auth().signOut().then(() => {
        //     firebase.auth().signInAnonymously()
        //       .then(({user}) => {
        //         console.log('user created. uid: ', user.uid)
        //         dispatch('setUser', user)
        //       })
        //       .catch(function(error) {
        //         // Handle Errors here.
        //         console.error('SERIOUS ERROR at initAuth: ', error.message)
        //         window.alert('エラーが発生しました。再読み込みしてください。もし複数回表示される場合は、時間をおいてやり直してください。')
        //       });
        //   })
        // } else {
        //   // console.log('user already signed in. uid: ', user.uid)
        // }
        dispatch('setUser', user)
      } else {
        firebase.auth().signInAnonymously()
        .then(({user}) => {
          console.log('user created. uid: ', user.uid)
          dispatch('setUser', user)
        })
        .catch(function(error) {
          // Handle Errors here.
          console.error('SERIOUS ERROR at initAuth: ', error)
          window.alert('エラーが発生しました。再読み込みしてください。もし複数回表示される場合は、時間をおいてやり直してください。')
        });
      }
    })
  },
  userInitiation(context){
    // localStorageにinitiationKeyがあるか確認し、もしあればそれをfunctionsに飛ばす
    const initiationKey = localStorage.getItem('initiationKey')
    if (initiationKey) {
      localStorage.removeItem('initiationKey')
      const functions = firebase.functions()
      const initiation = functions.httpsCallable('initiation')
      initiation({ key: initiationKey }).then(() => {
        window.location.reload()
      })
    }

    const user = context.state.user
    const memberdoc = firebase.firestore().collection('0').doc('config').collection('members').doc(user.uid)


    let counterdoc = memberdoc.collection("counter").doc("counter")
    Promise.all([
      // ユーザー初期化
      memberdoc.get().then((doc) => {
        if (!doc.exists) {
          // ドキュメントを作成する
          memberdoc.set({
            isActive: true,
            uid: user.uid,
            name: user.displayName ? user.displayName : '名無しさん',
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            position: "",
            hitokoto: "",
            relatedLink: "",
            lastlogin: firebase.firestore.Timestamp.now(),
          })
        } else {
          // lastloginを更新する
          memberdoc.update({
            lastlogin: firebase.firestore.Timestamp.now(),
          })
        }
      }),
      
      // 通知設定の確認
      firebase.firestore().collection('userConfig').doc(user.uid).get().then((doc) => {
        if (!doc.exists) {
          // ドキュメントを作成する
          firebase.firestore().collection('userConfig').doc(user.uid).set({
            uid: user.uid,
            isActive: true,
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            email: user.email ? user.email : null,
            notifyMail: user.emailVerified && !user.email?.endsWith("liqlid.local"),
          })
          context.commit('setAskForNotificationModalOpened', true)
        } else {
          // 新しくメール認証したユーザーを対象に、メールアドレスを更新する
          const docData = doc.data()
          if (user.emailVerified && docData?.email !== user.email) {
            firebase.firestore().collection('userConfig').doc(user.uid).update({
              email: user.email,
            })
          }
        }
      }),

      
      // ログインログ
      // TODO!: 時差どうするか問題は残る
      // 最も新しいloginlogの日付を取得
      memberdoc.collection("loginlog").orderBy("sort", "desc").limit(1).get().then((querySnapshot) => {
        if (!querySnapshot.empty) {
          querySnapshot.forEach((doc) => {
            // 最も新しいloginlogの日付を取得
            const lastloginlog_date = doc.data().date.toDate();
            const lastloginlog_str = lastloginlog_date.getFullYear() + "/" + (lastloginlog_date.getMonth() + 1) + "/" + lastloginlog_date.getDate();

            // 今日すでにloginlogを記入していないか調べる。
            const today = new Date();
            const today_str = today.getFullYear() + "/" + (today.getMonth() + 1) + "/" + today.getDate();
            // 今日の日付と最も新しいloginlogの日付を比較
            if (today_str == lastloginlog_str) {
              // 今日すでに記入していたら、記入しない。
              return;
            }
          });
        }
        const now_ms = getNowMs()
        // let collection = firebase.firestore().collection("0").doc("config").collection("members").doc(user.uid).collection("loginlog").doc(now_ms);
        let loginlogdoc = memberdoc.collection("loginlog").doc(now_ms);
        loginlogdoc.set({
          sort: now_ms,
          date: firebase.firestore.Timestamp.now(),
        })
        .then(function () {})
        .catch(function (error) {
          alert("ログの記入でエラーが発生しました。");
          console.error("Error adding document:", error);
        });
      }),
      

      // アクティビティカウンターの増加
      // incrementはupdateでしか使えない
      counterdoc.set(
        {
          isActive: true,
          lastupdate: firebase.firestore.Timestamp.now()
        },
        { merge: true }
      ),
      counterdoc.update({
        login_all: firebase.firestore.FieldValue.increment(1),
      }),

      // user.isGovStaffがtrueの場合かつ職員配列に配列に値が含まれていなければ、追加する
      // const promiseGovStaff = firebase.firestore().collection("0").doc("config").collection("admins").doc("govstaffs").get().then((doc) => {
      //   if(doc.exists){
        // doc.data().govstaffs
      //   }
      // })
      // 取得コードを参考にする
      (async () => {
        // 職員番号が有効化されていないか、そもそも職員でない場合はreturn
        if (authConfig.officer !== 1 || !user.isGovStaff) {
          return
        }
        const doc = await firebase.firestore().collection("0").doc("config").collection("admins").doc("govstaffs").get()
        if(doc.exists){
          const govstaffs = doc.data().govstaffs
          if (!govstaffs.includes(user.uid)) {
            await firebase.firestore().collection("0").doc("config").collection("admins").doc("govstaffs").update({
              govstaffs: firebase.firestore.FieldValue.arrayUnion(user.uid)
            })
          }
        } else {
          await firebase.firestore().collection("0").doc("config").collection("admins").doc("govstaffs").set({
            govstaffs: [user.uid]
          })
        }
      })(),
      // ユーザー属性の確認。定義ファイルがあれば、モーダルを表示する。
      // モーダルを表示するかどうかを判別するstoreに定義を保存する。
      firebase.firestore().doc('/0/config/attributionDefs/default').get().then((doc) => {
        const attributionDefString = doc.data()?.def
        if (attributionDefString && !user.isGovStaff) {
          const attributionDef = JSON.parse(attributionDefString)
          context.commit('setAttributionDef', attributionDef)
          firebase.firestore().collection('userAttribute').doc(user.uid).get().then((doc) => {
            // ドキュメントが存在しない場合は未回答。アンケート初期入力を行うために、isNotAnsweredがtrueの場合も未回答判定とする。
            const forceOpen = window.localStorage.getItem('attributionOpen') == 'true';
            if (forceOpen && cityId != 'kotoura-town') window.localStorage.removeItem('attributionOpen')
            if (!doc.exists || doc.data()?.isNotAnswered || forceOpen) {
              context.commit('setAttributionModalOpened', true)
            }
          })
        }
      }),
    ]).then(() => {
      // 親モジュールのactionsを呼び出す
      context.dispatch('getLogoSrc', null, { root: true })
      context.dispatch('getMem', null, { root: true })
      context.dispatch('getLid', null, { root: true })
      context.dispatch('getwss', null, { root: true })
    })
  },
  unAuthedUserInitiation(context){
    const user = context.state.user
    if (window.localStorage.getItem('forceAttributionModal') == 'true') {
      if (cityId != 'kotoura-town') window.localStorage.removeItem('forceAttributionModal');
      firebase.firestore().doc('/0/config/attributionDefs/default').get().then((doc) => {
        const attributionDefString = doc.data()?.def
        if (attributionDefString && !user.isGovStaff) {
          const attributionDef = JSON.parse(attributionDefString)
          context.commit('setAttributionDef', attributionDef)
          context.commit('setAttributionModalOpened', true)
        }
      })
    }
  },

  setAskForNotificationModalClosed({ commit, dispatch }) {
    commit('setAskForNotificationModalOpened', false)
  },

  setAttributionModalClosed({ commit, dispatch }) {
    commit('setAttributionModalOpened', false)
  },
  
}

// TODO?: この方法で取得するかは要検討。そのままstateにまとめて良さそう
// const getters = {
//   isAdmin: state => state.user ? state.user.getIdTokenResult().then(idTokenResult=>idTokenResult.claims.admin) : null,
//   isLiqAdmin: state => state.user ? state.user.getIdTokenResult().then(idTokenResult=>idTokenResult.claims.liqadmin) : null,
//   line: state => state.user ? state.user.getIdTokenResult().then(idTokenResult=>idTokenResult.claims.line) : null,
//   xid: state => state.user ? state.user.getIdTokenResult().then(idTokenResult=>idTokenResult.claims.xid) : null,
// }

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  // getters
};

function getNowMs(date=new Date()){
  let yyyy = date.getFullYear()
  let mm = date.getMonth() + 1
  mm += "";
  if (mm.length === 1) mm = "0" + mm
  let dd = date.getDate()
  dd += "";
  if (dd.length === 1) dd = "0" + dd
  let hh = date.getHours()
  hh += "";
  if (hh.length === 1) hh = "0" + hh
  let mi = date.getMinutes()
  mi += "";
  if (mi.length === 1) mi = "0" + mi
  let se = date.getSeconds()
  se += "";
  if (se.length === 1) se = "0" + se
  let ms = date.getMilliseconds()
  ms += "";
  if (ms.length === 1) ms = "0" + ms
  return yyyy + mm + dd + hh + mi + se + ms
}